import React from 'react';

import { corporate_landing_path } from '../../routes.js';

const CorporateInquiry = () => {
  return (
    <div className="text-center mt-32 text-subtitle-serif font-sans font-bold text-primary-black">
      Interested in a group or corporate subscription?
      <a href={corporate_landing_path()} className="ml-4 text-primary-red visited:text-primary-red">
        Inquire here
      </a>
    </div>
  );
};

export default CorporateInquiry;
